import type { Options } from "ky";
import { BaseUrl } from "@/types/base-url";
import clientFetch from "./client-fetch";

export default async function clientFetchMutation<T>(
	url: string,
	{ arg }: { arg: Options },
	type: BaseUrl = BaseUrl.DEFAULT,
) {
	return await clientFetch<T>([url, arg], type);
}
